var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticStyle:{"cursor":"pointer"},attrs:{"id":"countdown2"},on:{"click":function($event){return _vm._setInterval()}}},[_vm._v("Tiempo"+_vm._s(_vm.countdown))])])}
var staticRenderFns = []

export { render, staticRenderFns }